import styled from 'styled-components';

export const Container = styled.div`
  min-height: 200px;
  overflow-y: scroll;
`;
